import { Close } from 'components/Icons/Icons'
import Link from 'components/Link'
import { AnimatePresence, motion } from 'framer-motion'
import useiCloudReady from '../../hooks/useiCloudReady'
import React, { useEffect, useState } from 'react'
import GitHubButton from 'react-github-btn'
import { LinkedinIcon } from 'components/LinkedinIcon'

export default function StarUsBanner() {
    const icloudready = useiCloudReady()
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const hideBanner = window?.localStorage?.getItem('hide-banner')
            setVisible(hideBanner !== 'true')
        }
    }, [])

    const handleClick = () => {
        setVisible(false)
        if (typeof window !== 'undefined') {
            window.localStorage.setItem('hide-banner', 'true')
        }
    }
    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    key="star-us-banner"
                    initial={{ translateY: 'calc(100% + 23px)', opacity: 0 }}
                    animate={{ translateY: '0%', opacity: 1 }}
                    exit={{ translateY: 'calc(100% + 23px)', opacity: 1 }}
                    className="fixed bottom-0 sm:bottom-[23px] z-[9998] w-full sm:w-[350px] sm:left-[calc(50%_-_175px)] flex justify-center items-center"
                >
                    <div className="flex space-x-4 bg-red/80 sm:bg-red py-[12px] px-[25px] text-white sm:rounded-full w-full sm:w-auto sm:items-center">
                        <p className="mx-auto m-0 sm:pr-1 text-[15px] font-semibold flex items-center space-x-4">
                            {icloudready?.isFeatureEnabled('cairo-banner') ? (
                                <Link to="/webinars-events/cairo" className="text-white hover:text-white">
                                    Come say &#128075; at our Cairo meet-up!
                                </Link>
                            ) : (
                                <>
                                    <Link to="/book-a-meeting" className="text-white hover:text-white">
                                        <span>Schedule a demo</span>
                                    </Link>
                                    {/* <LinkedinIcon companyname="icloud-ready" /> */}
                                    {/* <span className="h-[28px] w-[125px]">
                                        <GitHubButton
                                            className="text-red hover:text-red"
                                            href="https://github.com/icloud-ready/icloudready"
                                            data-size="large"
                                            data-show-count="true"
                                            aria-label="Follow icloudready on Linkedin"
                                        >
                                             Follow
                                        </GitHubButton>
                                    </span> */}
                                </>
                            )}
                        </p>
                        <button className="text-white ml-auto" onClick={handleClick}>
                            <Close className="w-3 h-3 relative hover:scale-[1.1] active:top-[0.5px] active:scale-[.99]" />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
